import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import {
  // Avatar,
  Chip,
  // Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ReplaceData } from 'services/CommonServices';
import { alertOptions } from 'utils/Config';
import { MASTER_ENDPOINT } from 'utils/Constant';

import UserAssignConfirmation from './userAssignConfirmation';
import { JobUserAssigned, User } from './utils';

interface UserAssignModalProps {
  open: boolean;
  onClose: () => void;
  onAssignUser: (userId: string, type: 'add' | 'remove') => void;
  jobId: string;
  jobTitle: string;
  anchorEl: HTMLElement | null;
  users: User[];
  exisitngAssignedUsers?: JobUserAssigned[];
}

const UserAssignModal: React.FC<UserAssignModalProps> = ({
  open,
  onClose,
  onAssignUser,
  jobId,
  // jobTitle,
  anchorEl,
  users,
  exisitngAssignedUsers,
}) => {
  const [selectedUser, setSelectedUser] = useState({
    id: '',
    name: '',
    open: false,
    teamId: '',
    teamUserRole: '',
    type: '' as 'add' | 'remove',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [loader, setLoader] = useState(false);

  const filteredUsers = React.useMemo(() => {
    const term = (searchTerm || '').trim().toLowerCase();
    const assignedSet = new Set(
      (exisitngAssignedUsers || []).map((u) => u.userId),
    );

    const base = users.filter((user) => {
      const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`
        .trim()
        .toLowerCase();
      const email = (user?.login?.email || '').toLowerCase();
      if (!term) return true;
      return fullName.includes(term) || email.includes(term);
    });

    base.sort((a, b) => {
      const aAssigned = assignedSet.has(a.id) ? 0 : 1;
      const bAssigned = assignedSet.has(b.id) ? 0 : 1;
      if (aAssigned !== bAssigned) return aAssigned - bAssigned;
      const aName = `${a?.firstName || ''} ${a?.lastName || ''}`.trim();
      const bName = `${b?.firstName || ''} ${b?.lastName || ''}`.trim();
      return aName.localeCompare(bName);
    });

    return base;
  }, [users, searchTerm, exisitngAssignedUsers]);

  const getAvatarColor = (initials: string) => {
    const colors = [
      '#8b5cf6', // Purple
      '#06b6d4', // Cyan
      '#10b981', // Green
      '#f59e0b', // Amber
      '#ef4444', // Red
      '#6366f1', // Indigo
    ];
    const index = initials.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const handleUserSelect = (
    userId: string,
    teamId: string,
    teamUserRole: string,
    userName: string,
    type: 'add' | 'remove',
  ) => {
    setSelectedUser({
      id: userId,
      name: userName,
      open: true,
      teamId,
      teamUserRole,
      type,
    });
  };

  const closeConfirmation = () => {
    setSelectedUser({
      id: '',
      name: '',
      open: false,
      teamId: '',
      teamUserRole: '',
      type: '' as 'add' | 'remove',
    });
  };
  const handleUserClick = (
    userId: string,
    teamId: string,
    teamUserRole: string,
    type: 'add' | 'remove',
  ) => {
    try {
      const initialAssignedIds = new Set(
        exisitngAssignedUsers.map((user) => user.userId),
      );
      const currentAssignedIds = [...Array.from(initialAssignedIds), userId];
      const removedUsersData = Array.from(initialAssignedIds).filter(
        (id) => id === userId,
      );
      const payload = {
        assignUserRole: teamUserRole,
        assignedTo: Array.from(currentAssignedIds).filter(
          (id) => !removedUsersData.includes(id),
        ),
        removedUsers: removedUsersData,
        teamId: teamId,
      };
      setLoader(true);
      ReplaceData(jobId, payload, `${MASTER_ENDPOINT.JobPostingAssign}`)
        .then((res) => {
          setLoader(false);
          onAssignUser(userId, type);
          closeConfirmation();
          toast.success(
            `User ${
              type === 'add' ? 'added to' : 'removed from'
            } job successfully`,
            alertOptions,
          );
        })
        .catch((err) => {
          setLoader(false);
          const errorMessage =
            err ||
            err?.error?.data?.message ||
            err?.error?.message ||
            err?.message ||
            'Failed to close job';
          toast.error(errorMessage, alertOptions);
        });
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <>
      <Popover
        open={open}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            marginTop: '8px',
            maxHeight: '80vh',
            width: '400px',
          },
        }}>
        {/* Header */}
        <div
          style={{
            alignItems: 'center',
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px 24px 16px 24px',
          }}>
          <Typography
            sx={{
              color: '#111827',
              fontFamily: 'Red Hat Display Medium',
              fontSize: '18px',
              fontWeight: '600',
            }}>
            Assign to
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
              padding: '4px',
            }}>
            <CloseIcon sx={{ color: '#6b7280', fontSize: '20px' }} />
          </IconButton>
        </div>

        {/* Content */}
        <div style={{ padding: '0' }}>
          {/* Search Bar */}
          <div
            style={{
              borderBottom: '1px solid #e5e7eb',
              padding: '16px 24px',
            }}>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                position: 'relative',
              }}>
              <SearchIcon
                sx={{
                  color: '#9ca3af',
                  fontSize: '20px',
                  left: '12px',
                  position: 'absolute',
                  zIndex: 1,
                }}
              />
              <TextField
                fullWidth
                placeholder="Search name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  '& .MuiInputBase-input': {
                    padding: '0 39px !important',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#d1d5db',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#6366f1',
                    },
                    '&:hover fieldset': {
                      borderColor: '#9ca3af',
                    },
                    borderRadius: '8px',
                    fontFamily: 'Red Hat Display Medium',
                    fontSize: '14px',
                    padding: 'unset',
                  },
                }}
              />
              {/* <IconButton
              sx={{
                '&:hover': {
                  backgroundColor: '#f3f4f6',
                },
                padding: '4px',
                position: 'absolute',
                right: '8px',
              }}>
              <FilterListIcon sx={{ color: '#9ca3af', fontSize: '20px' }} />
            </IconButton> */}
            </div>
          </div>

          {/* User List */}
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <List sx={{ padding: '0' }}>
              {filteredUsers.map((user) => {
                const exist = exisitngAssignedUsers.find(
                  (e) => e.userId === user.id,
                );
                return (
                  <ListItem
                    key={user.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      // handleUserClick(user.id, exist ? 'remove' : 'add');
                      handleUserSelect(
                        user.id,
                        user.teamId,
                        user.teamUserRole,
                        `${user.firstName} ${user.lastName}`,
                        exist ? 'remove' : 'add',
                      );
                    }}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#f9fafb',
                      },
                      '&:not(:last-child)': {
                        borderBottom: '1px solid #f3f4f6',
                      },
                      cursor: 'pointer',
                      justifyContent: 'space-between',
                      padding: '12px 24px',
                    }}>
                    <div
                      style={{
                        alignItems: 'center',
                        display: 'flex',
                      }}>
                      <ListItemAvatar>
                        {
                          // user?.imageId ? (
                          //   <img
                          //     style={{
                          //       borderRadius: '50%',
                          //       color: 'transparent',
                          //       height: '45px',
                          //       objectFit: 'cover',
                          //       overflow: 'hidden',
                          //       textAlign: 'center',
                          //       textIndent: '10000px',
                          //       width: '45px',
                          //     }}
                          //     alt=""
                          //     src={`${process.env.REACT_APP_APIURL}${
                          //       MASTER_ENDPOINT.Files
                          //     }/${String(user?.imageId)}`}
                          //     loading="lazy"
                          //   />
                          // ) :
                          <div
                            style={{
                              alignItems: 'center',
                              backgroundColor: getAvatarColor(
                                user?.firstName || user?.lastName,
                              ),
                              borderRadius: '50%',
                              color: 'white',
                              display: 'flex',
                              fontFamily: 'Red Hat Display Medium',
                              fontSize: '14px',
                              fontWeight: '500',
                              height: '40px',
                              justifyContent: 'center',
                              width: '40px',
                            }}>
                            {user?.firstName?.charAt(0).toUpperCase() || ''}
                            {user?.lastName?.charAt(0).toUpperCase() || ''}
                          </div>
                        }
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              color: '#111827',
                              fontFamily: 'Red Hat Display Medium',
                              fontSize: '14px',
                              fontWeight: '500',
                            }}>
                            {user?.firstName} {user?.lastName}
                          </Typography>
                        }
                        secondary={
                          <Typography
                            sx={{
                              color: '#6b7280',
                              fontFamily: 'Red Hat Display Regular',
                              fontSize: '12px',
                            }}>
                            {user?.login?.email}
                          </Typography>
                        }
                      />
                    </div>

                    {exist ? (
                      <ListItemText
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                        primary={
                          <Chip
                            label={'Remove'}
                            sx={{
                              backgroundColor: '#fef2f2',
                              border: '1px solid #fecaca',
                              color: '#dc2626',
                              fontFamily: 'Red Hat Display Medium',
                              fontSize: '10px',
                              fontWeight: '600',
                              height: '20px',
                            }}
                          />
                        }
                      />
                    ) : null}
                  </ListItem>
                );
              })}
            </List>
          </div>

          {/* Empty State */}
          {filteredUsers.length === 0 && (
            <div
              style={{
                padding: '40px 24px',
                textAlign: 'center',
              }}>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                }}>
                No users found
              </Typography>
            </div>
          )}
        </div>
      </Popover>
      {selectedUser.open || loader ? (
        <UserAssignConfirmation
          open={Boolean(selectedUser.open) || loader}
          handleClose={() => closeConfirmation()}
          onSubmit={() =>
            handleUserClick(
              selectedUser.id,
              selectedUser.teamId,
              selectedUser.teamUserRole,
              selectedUser.type,
            )
          }
          userName={selectedUser?.name}
          type={selectedUser?.type}
          loader={loader}
        />
      ) : null}
    </>
  );
};

export default UserAssignModal;
